import { JUNGLE_APP_ORIGIN } from "./appHandoff";

/** Warm the versioned app module after a valid upload starts, without executing it. */
export function preloadLandingApp(): void {
  // Preview/local build hashes may not exist on the production app origin.
  if (typeof document === "undefined") return;
  const isProductionLandingHost = ["jungleai.com", "www.jungleai.com"].includes(window.location.hostname);
  if (!isProductionLandingHost) return;
  const connection = (navigator as Navigator & { connection?: { saveData?: boolean; effectiveType?: string } }).connection;
  const isConstrainedConnection = connection?.saveData || ["slow-2g", "2g"].includes(connection?.effectiveType ?? "");
  if (isConstrainedConnection) return;
  if (document.querySelector("link[data-landing-app-preload]")) return;
  const path = document.querySelector<HTMLMetaElement>('meta[name="jungle-app-bootstrap"]')?.content;
  if (!path || !/^\/assets\/renderJungleWebApp-[\w-]+\.js(?:\?dpl=dpl_[\w-]+)?$/.test(path)) return;
  const link = document.createElement("link");
  link.rel = "modulepreload";
  link.crossOrigin = "anonymous";
  link.href = new URL(path, JUNGLE_APP_ORIGIN).href;
  link.dataset.landingAppPreload = "true";
  document.head.appendChild(link);
}
